/* eslint-disable camelcase */
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogActions } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { deleteInvoiceAddressById } from 'src/shared/services/invoiceAddressService';

type InvoiceAddressConfirmDeleteDialogProps = {
  invoiceAddress_id: number;
  callback: (accepted: boolean) => void;
};

export const InvoiceAddressConfirmDeleteDialog = (props: InvoiceAddressConfirmDeleteDialogProps) => {
  const { invoiceAddress_id, callback } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();
  const { t } = useTranslation(['common', 'member']);
  const [open, setOpen] = React.useState(true);

  const confirm = useCallback(async () => {
    setLoading(true);
    try {
      await deleteInvoiceAddressById(invoiceAddress_id);
      if (isMounted()) {
        toast.success(<>{t('member:invoiceAddress.deleteSuccess')}</>);
        callback(true);
      }
    } catch (e) {
      if (isMounted()) ConsoleHelper.log(e);
    } finally {
      if (isMounted()) {
        setLoading(false);
        setOpen(false);
      }
    }
  }, [callback, invoiceAddress_id, isMounted, t]);

  const handleClose = () => {
    callback(false);
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{t('member:invoiceAddress.confirmDelete')}</DialogTitle>
      <DialogActions sx={{ '& .MuiButton-text': { fontWeight: 600 } }}>
        <LoadingButton onClick={handleClose} loading={loading}>
          {t('common:button.no')}
        </LoadingButton>
        <LoadingButton onClick={confirm} variant='contained' color='success' disableElevation autoFocus loading={loading}>
          {t('common:button.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
